import { Modal } from '@ui/components'

export default function TipsModal({ onClose, isOpen }: {readonly onClose: () => void; readonly isOpen: boolean}) {
	return (
		<Modal
			isOpen={ isOpen }
			title='💡 Tips to use VirtualBrain'
			size='medium'
			onClose={ onClose }
		>
			<div className='text-sm'>
				Your VirtualBrain needs context and specific questions. <br />
				The more precise your questions, the better the answers will be.
				<table className='min-w-full table-auto mb-4 mt-4'>
					<thead className='justify-between text-sm'>
						<tr className='bg-gray-100'>
							<th className='px-2 py-2 text-center w-[50%]'>
								<span className='font-bold text-gray-600 uppercase'>❌ Instead of</span>
							</th>
							<th className='px-2 py-2 text-center w-[50%]'>
								<span className='font-bold text-gray-600 uppercase'>✅ Try</span>
							</th>
						</tr>
					</thead>
					<tbody className='bg-white divide-y divide-light-blue-500  text-gray-900 text-xs'>
						<tr>
							<td className='text-center px-2 py-2'>
								Summarize the last document
							</td>
							<td className='text-center px-2 py-2'>
								Summarize the content of the report on XYZ topic
							</td>
						</tr>
						<tr>
							<td className='text-center px-2 py-2'>
								What does the document XYZ talk about?
							</td>
							<td className='text-center px-2 py-2'>
								What are the key takeaways of [document name]
							</td>
						</tr>
						<tr>
							<td className='text-center px-2 py-2'>
								Strategy of XYZ
							</td>
							<td className='text-center px-2 py-2'>
								Detail the strategy of XYZ to conquer the market ABC
							</td>
						</tr>
						<tr>
							<td className='text-center px-2 py-2'>
								What are the financial results of XYZ?
							</td>
							<td className='text-center px-2 py-2'>
								What is the breakdown by entity of Q1 Financial results of XYZ?
							</td>
						</tr>
					</tbody>
				</table>
				If you still cannot get a proper answer, it is most likely that we <b>could not read properly your document</b>, or that the data you are looking for is in a <b>complex table or a highly stylized image</b>. We are doing our best to fix those issues.
				<br /><br />
				Do not hesitate to join our
				<a
					href='https://join.slack.com/t/virtualbrainusers/shared_invite/zt-1xkgmfyh3-lZ3pEkG_FQRrlg28dtsrdg'
					target='_blank'
					rel='noopener noreferrer'
					className='underline p-1'
				>
					Slack Community
				</a>
				to obtain further support and help us make VirtualBrain better 🙏
			</div>
		</Modal>
	)
}
